/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goal_Reached_DescriptionInputs */

const en_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra donations earn you an exclusive tree, but it won't add real trees to our goal.`)
};

const ar_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتيح لك التبرعات الإضافية الحصول على شجرة حصرية، لكنها لن تضيف أشجارًا حقيقية إلى هدفنا.`)
};

const de_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzliche Spenden bringen dir einen exklusiven Baum ein, erhöhen jedoch nicht die Anzahl der echten Bäume für unser Ziel.`)
};

const es_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las donaciones extra te permiten obtener un árbol exclusivo, pero no añadirán árboles reales a nuestro objetivo.`)
};

const fr_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les dons supplémentaires vous permettent d'obtenir un arbre exclusif, mais n'ajouteront pas d'arbres réels à notre objectif.`)
};

const it_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le donazioni extra ti permettono di ottenere un albero esclusivo, ma non aggiungeranno alberi veri al nostro obiettivo.`)
};

const ja_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標達成後も寄付を続けて限定樹種を獲得できますが、実際に植樹される樹木の数には加算されません。`)
};

const ko_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목표 달성 후에도 기부하여 한정 나무를 획득할 수 있지만, 실제 심어지는 나무 수에는 추가되지 않습니다.`)
};

const pt_br_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doações extras rendem uma árvore exclusiva, mas não adicionarão árvores reais ao nosso objetivo.`)
};

const ru_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные пожертвования позволяют получить эксклюзивное дерево, но они не добавят реальных деревьев к нашей цели.`)
};

const th_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การบริจาคเพิ่มเติมจะช่วยให้คุณได้รับต้นไม้สุดพิเศษ แต่จะไม่เพิ่มจำนวนต้นไม้จริงในเป้าหมายของเรา`)
};

const tr_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ek bağışlar size özel bir ağaç kazandırır ancak hedefimize gerçek ağaçlar eklemez.`)
};

const zh_cn_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`达标后仍可捐赠森林能量并获得限定树种，但不再增加捐献的真树数量。`)
};

const zh_tw_goal_reached_description = /** @type {(inputs: Goal_Reached_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`達標後仍可捐贈森林能量，並獲得限定樹種，但不再增加捐贈的真樹數量。`)
};

/**
* | output |
* | --- |
* | "Extra donations earn you an exclusive tree, but it won't add real trees to our goal." |
*
* @param {Goal_Reached_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const goal_reached_description = /** @type {((inputs?: Goal_Reached_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goal_Reached_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goal_reached_description(inputs)
	if (locale === "ar") return ar_goal_reached_description(inputs)
	if (locale === "de") return de_goal_reached_description(inputs)
	if (locale === "es") return es_goal_reached_description(inputs)
	if (locale === "fr") return fr_goal_reached_description(inputs)
	if (locale === "it") return it_goal_reached_description(inputs)
	if (locale === "ja") return ja_goal_reached_description(inputs)
	if (locale === "ko") return ko_goal_reached_description(inputs)
	if (locale === "pt_br") return pt_br_goal_reached_description(inputs)
	if (locale === "ru") return ru_goal_reached_description(inputs)
	if (locale === "th") return th_goal_reached_description(inputs)
	if (locale === "tr") return tr_goal_reached_description(inputs)
	if (locale === "zh_cn") return zh_cn_goal_reached_description(inputs)
	return zh_tw_goal_reached_description(inputs)
});